import React from 'react';
import { aboutParagraphs, education, profile } from '../mock';
import { Linkedin } from 'lucide-react';
import BackToTop from './BackToTop';

const AboutSidebar = () => (
  <div className="sticky top-28">
    <div className="section-eyebrow">About</div>
    <h2 className="font-display text-4xl md:text-5xl text-[#0c1a2b] mt-4 leading-tight">
      A practitioner at the intersection of
      <span className="italic text-[#c9a961]"> business </span>
      and
      <span className="italic text-[#c9a961]"> quality</span>.
    </h2>
    <div className="gold-line mt-6" />
  </div>
);

const EducationBlock = () => (
  <div className="border-l-2 border-[#c9a961] pl-5">
    <div className="text-[11px] tracking-[0.3em] uppercase text-[#5b6b7d]">Education</div>
    {education.map((e) => (
      <div key={e.degree} className="mt-2">
        <div className="font-display text-lg text-[#0c1a2b]">{e.degree}</div>
        <div className="text-sm text-[#5b6b7d]">{e.institution}</div>
      </div>
    ))}
  </div>
);

const ConnectBlock = ({ linkedin }) => (
  <div className="border-l-2 border-[#c9a961] pl-5">
    <div className="text-[11px] tracking-[0.3em] uppercase text-[#5b6b7d]">Connect</div>
    <a
      href={linkedin}
      target="_blank"
      rel="noreferrer"
      className="mt-2 inline-flex items-center gap-2 font-display text-lg text-[#0c1a2b] hover:text-[#c9a961] transition-colors"
    >
      <Linkedin size={18} /> LinkedIn Profile
    </a>
    <div className="text-sm text-[#5b6b7d] mt-1">/in/vigneshsofficial</div>
  </div>
);

const AboutBody = () => (
  <div className="lg:col-span-8">
    <div className="space-y-6 text-[17px] leading-[1.8] text-[#1c2f44]">
      {aboutParagraphs.map((p) => (
        <p key={p.slice(0, 48)}>{p}</p>
      ))}
    </div>
    <div className="mt-12 grid sm:grid-cols-2 gap-8">
      <EducationBlock />
      <ConnectBlock linkedin={profile.linkedin} />
    </div>
  </div>
);

const About = () => (
  <section id="about" className="bg-paper py-24 lg:py-32">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-14">
      <div className="lg:col-span-4">
        <AboutSidebar />
      </div>
      <AboutBody />
    </div>
    <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-16">
      <BackToTop targetId="about" label="Top of About" variant="light" />
    </div>
  </section>
);

export default About;
